module.exports = __webpack_public_path__ + "static/media/cover_abi_englisch.095238f2.jpg";